function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as d, jsxs as G } from "react/jsx-runtime";
import * as n from "react";
import { useMediaBorderRadius as J, ImageContent as M, ImageError as O } from "./image.js";
import { AspectRatioContainer as P } from "./utils/aspect-ratio-support.js";
import { isRunningAcceptanceTest as Q } from "./utils/platform.js";
import { video as X } from "./video.css-mistica.js";
import { vars as Y } from "./skins/skin-contract.css-mistica.js";
import { getPrefixedDataAttributes as $ } from "./utils/dom.js";
const q = {
    loading: {
        play: "playing",
        pause: "paused",
        fail: "error",
        finishLoad: "loaded"
    },
    /**
   * This state represents the scenario when video.load() finishes, but the video isn't played yet. Some browsers don't actually load
   * the video until someone plays it. In this case, we need to show the poster, because we may not have the first frame to display it.
   * https://stackoverflow.com/questions/10235919/the-canplay-canplaythrough-events-for-an-html5-video-are-not-called-on-firefox/26430919#26430919
   */ loaded: {
        play: "playing",
        pause: "paused",
        reset: "loading"
    },
    playing: {
        pause: "paused",
        reset: "loading"
    },
    paused: {
        play: "playing",
        reset: "loading"
    },
    error: {
        reset: "loading"
    }
}, D = (r, u)=>q[r][u] || r, K = {
    "1:1": 1,
    "16:9": 16 / 9,
    "4:3": 4 / 3
}, _ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC", z = /*#__PURE__*/ n.forwardRef((_param, A)=>{
    var { src: r , poster: u , autoPlay: p = "when-loaded" , muted: x = !0 , loop: N = !0 , preload: k = "none" , loadingTimeout: T = 1e4 , onLoad: y , onError: h , onPause: R , onPlay: b , aspectRatio: c = "1:1" , dataAttributes: B  } = _param, o = _object_without_properties(_param, [
        "src",
        "poster",
        "autoPlay",
        "muted",
        "loop",
        "preload",
        "loadingTimeout",
        "onLoad",
        "onError",
        "onPause",
        "onPlay",
        "aspectRatio",
        "dataAttributes"
    ]);
    const [a, l] = n.useReducer(D, "loading"), s = n.useRef(null), C = n.useRef(), f = n.useRef(null), w = J(), g = typeof c == "number" ? c : K[c], v = n.useCallback(()=>{
        a === "loading" && (l("fail"), h == null || h());
    }, [
        h,
        a
    ]);
    n.useEffect(()=>{
        var e;
        if (C.current !== r) {
            C.current = r;
            const t = setTimeout(v, T);
            return l("reset"), (e = s.current) == null || e.load(), ()=>{
                clearTimeout(t);
            };
        }
    }, [
        r,
        T,
        v
    ]);
    const I = ()=>{
        y == null || y();
        const e = s.current, t = p && !Q();
        l("finishLoad"), e && t && e.paused && e.play();
    }, U = (Array.isArray(r) ? r : [
        r
    ]).map((e)=>typeof e == "string" ? {
            src: e
        } : e), m = a === "error" || a === "loading" || a === "loaded", V = /* @__PURE__ */ d("video", {
        ref: s,
        playsInline: !0,
        disablePictureInPicture: !0,
        disableRemotePlayback: !0,
        muted: x,
        loop: N,
        className: X,
        preload: k,
        onError: v,
        onPause: ()=>{
            R == null || R(), l("pause");
        },
        onTimeUpdate: ()=>{
            var e;
            a !== "playing" && ((e = s.current) == null ? void 0 : e.currentTime) !== 0 && (b == null || b(), l("play"));
        },
        onCanPlay: ()=>{
            p === "streaming" && I();
        },
        onCanPlayThrough: ()=>{
            p !== "streaming" && I();
        },
        poster: _,
        style: {
            // For some reason adding this style with classnames doesn't add the border radius in safari
            borderRadius: w ? Y.borderRadii.container : 0,
            visibility: m ? "hidden" : "visible",
            position: m || g !== 0 ? "absolute" : "static",
            width: "100%",
            height: "100%"
        },
        children: U.map((param, i)=>/* @__PURE__ */ {
            let { src: e , type: t  } = param;
            return d("source", {
                src: e,
                type: t
            }, i);
        })
    }), E = !!(g !== 0 || o.width && o.height), F = a === "error", j = n.useMemo(()=>u ? /* @__PURE__ */ d(M, {
            aspectRatio: c,
            width: o.width,
            height: o.height,
            src: u
        }) : E ? /* @__PURE__ */ d("div", {
            style: {
                position: "absolute",
                width: "100%",
                height: "100%"
            },
            children: /* @__PURE__ */ d(O, {
                noBorderRadius: !w,
                withIcon: F
            })
        }) : void 0, [
        c,
        o.height,
        o.width,
        w,
        F,
        u,
        E
    ]);
    return /* @__PURE__ */ G(P, {
        style: {
            position: "relative"
        },
        aspectRatio: g,
        width: o.width,
        height: o.height,
        dataAttributes: $(B, "Video"),
        children: [
            /* @__PURE__ */ d("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                },
                ref: (e)=>{
                    const t = e || null;
                    t && (t.play = ()=>{
                        var i;
                        return ((i = s.current) == null ? void 0 : i.play()) || Promise.resolve();
                    }, t.pause = ()=>{
                        var i;
                        return (i = s.current) == null ? void 0 : i.pause();
                    }, t.load = ()=>{
                        var i;
                        (i = f.current) != null && i.style && (f.current.style.width = "100%", f.current.style.height = "100%"), setTimeout(()=>{
                            var S;
                            l("reset"), (S = s.current) == null || S.load();
                        }, 100);
                    }, t.setCurrentTime = (i)=>{
                        s.current && (s.current.currentTime = i);
                    }), typeof A == "function" ? A(t) : A && (A.current = t);
                }
            }),
            V,
            /* @__PURE__ */ d("div", {
                ref: f,
                style: {
                    position: g !== 0 ? "absolute" : "static",
                    width: m ? "100%" : 0,
                    height: m ? "100%" : 0,
                    overflow: "hidden"
                },
                children: j
            })
        ]
    });
}), re = z;
export { K as RATIO, re as default };
